/**
 * @group UI
 * @summary Sidebar-specific constants
 * 
 * @remarks
 * This constant contains values specific to sidebar functionality,
 * including dimensions, timing, and configuration values.
 * 
 * @example
 * ```typescript
 * import { SIDEBAR_CONSTANTS } from '@shared/constants';
 * 
 * const cookieMaxAge = SIDEBAR_CONSTANTS.COOKIE_MAX_AGE;
 * const sidebarWidth = SIDEBAR_CONSTANTS.WIDTH;
 * ```
 */
export const SIDEBAR_CONSTANTS = {
  // Cookie configuration
  COOKIE_MAX_AGE: 60 * 60 * 24 * 7, // 7 days in seconds
  
  // Dimensions
  WIDTH: '16rem',
  WIDTH_MOBILE: '18rem',
  WIDTH_ICON: '3rem',
  
  // Keyboard shortcuts
  KEYBOARD_SHORTCUT: 'b',
} as const;
